// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__.O(undefined, ["vendors-node_modules_babel_polyfill_lib_index_js-node_modules_consta_icons_IconAdd_index_js-n-5871ee"], () => (__webpack_require__("./node_modules/@babel/polyfill/lib/index.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_babel_polyfill_lib_index_js-node_modules_consta_icons_IconAdd_index_js-n-5871ee"], () => (__webpack_require__("./src/index.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
